import { BareActionContext } from 'vuex-typex'
import { UserState } from '../state'
import { RootState } from '../..'
import userUtils from './user-utils'
import fetchFollowers from './fetch-followers'
import { IUser } from '../../../model/user'

export default async function unfollowUser(context: BareActionContext<UserState, RootState>, user: IUser)
{
    userUtils.userService.unfollow(user).then((result: any) => {
        fetchFollowers(context, user)
    })

    return
}
